import React, { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import styles from './SimplexCheckout.module.scss';

let BACKEND_API = process.env.REACT_APP_SIMPLEX_API;
let EVENT_REQ_API_URL_ENDPOINT = BACKEND_API + '/tower/events';

const SimplexCheckout = () => {
  const params = useParams();
  const history = useHistory();
  const { paymentId, playerId } = params;

  useEffect(() => {
    
    // this is required parameter type defined by Simplex, 
    // the key should be `payment_id` and `paymentId` is the actual payment id we had generated
    const simplexParams = {
      payment_id: paymentId
    }


    // if paymentId exists load the Simplex widget for payment
    if(paymentId) {
      window.Simplex.load(simplexParams, function (event) {
        console.log("Proceeding with Simplex payments. Status: " + event.type);
      });

      // subscribe to the payments flow so that we can detect whether the payments was completed or not
      // upon successful completion fire an event that fetches events API for payments
      window.Simplex.subscribe('onlineFlowFinished', async function (event) {
        console.log("Checkout process completed. Status: ", event.payload.result) // => "success" or "failure"
        
        // should call the events API here
        if(event.payload.result === "success") {

          // build request body to sent for simplex API to get event details for a particular payments id
          const requestBody = {
            "paymentId": paymentId,
            "playerId": playerId, // hard-coded should be replaced with user-id here
          }
                 
          // event fetching code block
          let eventData;
          try {
            eventData = await axios.post(EVENT_REQ_API_URL_ENDPOINT, requestBody);
          } catch(error) {
            console.log("There was an error in processing your request. Error: ", error);
          }

          console.log("Events data processed successfully. ", eventData.data);
          console.log("Done. Redirecting to home page");

          // redirection to home page
          history.push('/');
        }

        else if(event.payload.result === "failure") {
          // redirection to home page
          history.push('/');
        }

        else {
          // redirection to home page for all other cases
          history.push('/');
        }
      });
      
    // else just redirect to home page
    } else {
      history.push('/');
    }

  }, [paymentId]);

  return (
    <div className={styles.SimplexCheckOut}>
      <form id="simplex-form">
          <div id="checkout-element">
          </div>
      </form>
    </div>
  )
}

export { SimplexCheckout };